// src/pages/AiGesprekkenPage.js
//
// Alle gesprekken met Doortje, bereikbaar via het menu Meer. Zo kun je ook buiten
// het dashboard een ouder gesprek kiezen; de chat opent dan met dat gesprek.
import React from 'react';
import AiGesprekkenLijst from '../components/AiGesprekkenLijst';
import SEO from '../components/SEO';

export default function AiGesprekkenPage() {
  return (
    <main className="ai-gesprekken-pagina">
      <SEO title="Mijn gesprekken" noindex />
      <AiGesprekkenLijst variant="kaart" alles />
    </main>
  );
}
